import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"],
  _excluded2 = ["data"],
  _excluded3 = ["data"],
  _excluded4 = ["data"],
  _excluded5 = ["data"],
  _excluded6 = ["data"],
  _excluded7 = ["data"],
  _excluded8 = ["data"],
  _excluded9 = ["data"],
  _excluded10 = ["data"],
  _excluded11 = ["data"],
  _excluded12 = ["data"],
  _excluded13 = ["data"],
  _excluded14 = ["data"],
  _excluded15 = ["data"],
  _excluded16 = ["data"],
  _excluded17 = ["data"],
  _excluded18 = ["data"],
  _excluded19 = ["data"],
  _excluded20 = ["data"],
  _excluded21 = ["data"],
  _excluded22 = ["data"],
  _excluded23 = ["data"],
  _excluded24 = ["data"],
  _excluded25 = ["data"],
  _excluded26 = ["data"],
  _excluded27 = ["data"],
  _excluded28 = ["data"],
  _excluded29 = ["data"],
  _excluded30 = ["data"];
/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import { useQuery, useLazyQuery, useSuspenseQuery, useMutation } from 'data-fetching-client';
import * as Queries from './ApprovalsConfigurationRpc.dfc.new';
export function useGetApprovalConfigurationQuery(options) {
  const _useQuery = useQuery(Queries.GET_APPROVAL_CONFIGURATION_QUERY, options),
    {
      data
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getApprovalConfiguration: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetApprovalConfigurationLazyQuery(options) {
  const [getter, _ref] = useLazyQuery(Queries.GET_APPROVAL_CONFIGURATION_QUERY, options);
  const {
      data
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded2);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getApprovalConfiguration: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetApprovalConfigurationSuspenseQuery(options) {
  const _useSuspenseQuery = useSuspenseQuery(Queries.GET_APPROVAL_CONFIGURATION_QUERY, options),
    {
      data
    } = _useSuspenseQuery,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery, _excluded3);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getApprovalConfiguration: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetApproversQuery(options) {
  const _useQuery2 = useQuery(Queries.GET_APPROVERS_QUERY, options),
    {
      data
    } = _useQuery2,
    rest = _objectWithoutPropertiesLoose(_useQuery2, _excluded4);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getApprovers: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetApproversLazyQuery(options) {
  const [getter, _ref2] = useLazyQuery(Queries.GET_APPROVERS_QUERY, options);
  const {
      data
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded5);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getApprovers: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetApproversSuspenseQuery(options) {
  const _useSuspenseQuery2 = useSuspenseQuery(Queries.GET_APPROVERS_QUERY, options),
    {
      data
    } = _useSuspenseQuery2,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery2, _excluded6);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getApprovers: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function usePutApprovalConfigurationMutation(options) {
  const [getter, _ref3] = useMutation(Queries.PUT_APPROVAL_CONFIGURATION_MUTATION, options);
  const {
      data
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded7);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    putApprovalConfiguration: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useSendRequestToEnableApprovalsMutation(options) {
  const [getter, _ref4] = useMutation(Queries.SEND_REQUEST_TO_ENABLE_APPROVALS_MUTATION, options);
  const {
      data
    } = _ref4,
    rest = _objectWithoutPropertiesLoose(_ref4, _excluded8);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    sendRequestToEnableApprovals: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useListApproverCandidatesQuery(options) {
  const _useQuery3 = useQuery(Queries.LIST_APPROVER_CANDIDATES_QUERY, options),
    {
      data
    } = _useQuery3,
    rest = _objectWithoutPropertiesLoose(_useQuery3, _excluded9);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    listApproverCandidates: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useListApproverCandidatesLazyQuery(options) {
  const [getter, _ref5] = useLazyQuery(Queries.LIST_APPROVER_CANDIDATES_QUERY, options);
  const {
      data
    } = _ref5,
    rest = _objectWithoutPropertiesLoose(_ref5, _excluded10);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    listApproverCandidates: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useListApproverCandidatesSuspenseQuery(options) {
  const _useSuspenseQuery3 = useSuspenseQuery(Queries.LIST_APPROVER_CANDIDATES_QUERY, options),
    {
      data
    } = _useSuspenseQuery3,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery3, _excluded11);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    listApproverCandidates: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetAvailableApproversQuery(options) {
  const _useQuery4 = useQuery(Queries.GET_AVAILABLE_APPROVERS_QUERY, options),
    {
      data
    } = _useQuery4,
    rest = _objectWithoutPropertiesLoose(_useQuery4, _excluded12);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAvailableApprovers: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetAvailableApproversLazyQuery(options) {
  const [getter, _ref6] = useLazyQuery(Queries.GET_AVAILABLE_APPROVERS_QUERY, options);
  const {
      data
    } = _ref6,
    rest = _objectWithoutPropertiesLoose(_ref6, _excluded13);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAvailableApprovers: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetAvailableApproversSuspenseQuery(options) {
  const _useSuspenseQuery4 = useSuspenseQuery(Queries.GET_AVAILABLE_APPROVERS_QUERY, options),
    {
      data
    } = _useSuspenseQuery4,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery4, _excluded14);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAvailableApprovers: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function usePutAvailableApproversMutation(options) {
  const [getter, _ref7] = useMutation(Queries.PUT_AVAILABLE_APPROVERS_MUTATION, options);
  const {
      data
    } = _ref7,
    rest = _objectWithoutPropertiesLoose(_ref7, _excluded15);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    putAvailableApprovers: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetAvailableApproversForActorTypeQuery(options) {
  const _useQuery5 = useQuery(Queries.GET_AVAILABLE_APPROVERS_FOR_ACTOR_TYPE_QUERY, options),
    {
      data
    } = _useQuery5,
    rest = _objectWithoutPropertiesLoose(_useQuery5, _excluded16);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAvailableApproversForActorType: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetAvailableApproversForActorTypeLazyQuery(options) {
  const [getter, _ref8] = useLazyQuery(Queries.GET_AVAILABLE_APPROVERS_FOR_ACTOR_TYPE_QUERY, options);
  const {
      data
    } = _ref8,
    rest = _objectWithoutPropertiesLoose(_ref8, _excluded17);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAvailableApproversForActorType: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetAvailableApproversForActorTypeSuspenseQuery(options) {
  const _useSuspenseQuery5 = useSuspenseQuery(Queries.GET_AVAILABLE_APPROVERS_FOR_ACTOR_TYPE_QUERY, options),
    {
      data
    } = _useSuspenseQuery5,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery5, _excluded18);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAvailableApproversForActorType: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function usePutAvailableApproversForActorTypeMutation(options) {
  const [getter, _ref9] = useMutation(Queries.PUT_AVAILABLE_APPROVERS_FOR_ACTOR_TYPE_MUTATION, options);
  const {
      data
    } = _ref9,
    rest = _objectWithoutPropertiesLoose(_ref9, _excluded19);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    putAvailableApproversForActorType: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function usePutApprovalTemplateMutation(options) {
  const [getter, _ref10] = useMutation(Queries.PUT_APPROVAL_TEMPLATE_MUTATION, options);
  const {
      data
    } = _ref10,
    rest = _objectWithoutPropertiesLoose(_ref10, _excluded20);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    putApprovalTemplate: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useDeleteApprovalTemplateMutation(options) {
  const [getter, _ref11] = useMutation(Queries.DELETE_APPROVAL_TEMPLATE_MUTATION, options);
  const {
      data
    } = _ref11,
    rest = _objectWithoutPropertiesLoose(_ref11, _excluded21);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    deleteApprovalTemplate: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetApprovalDelegatesQuery(options) {
  const _useQuery6 = useQuery(Queries.GET_APPROVAL_DELEGATES_QUERY, options),
    {
      data
    } = _useQuery6,
    rest = _objectWithoutPropertiesLoose(_useQuery6, _excluded22);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getApprovalDelegates: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetApprovalDelegatesLazyQuery(options) {
  const [getter, _ref12] = useLazyQuery(Queries.GET_APPROVAL_DELEGATES_QUERY, options);
  const {
      data
    } = _ref12,
    rest = _objectWithoutPropertiesLoose(_ref12, _excluded23);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getApprovalDelegates: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetApprovalDelegatesSuspenseQuery(options) {
  const _useSuspenseQuery6 = useSuspenseQuery(Queries.GET_APPROVAL_DELEGATES_QUERY, options),
    {
      data
    } = _useSuspenseQuery6,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery6, _excluded24);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getApprovalDelegates: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function usePutApprovalDelegateMutation(options) {
  const [getter, _ref13] = useMutation(Queries.PUT_APPROVAL_DELEGATE_MUTATION, options);
  const {
      data
    } = _ref13,
    rest = _objectWithoutPropertiesLoose(_ref13, _excluded25);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    putApprovalDelegate: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useDeleteApprovalDelegateMutation(options) {
  const [getter, _ref14] = useMutation(Queries.DELETE_APPROVAL_DELEGATE_MUTATION, options);
  const {
      data
    } = _ref14,
    rest = _objectWithoutPropertiesLoose(_ref14, _excluded26);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    deleteApprovalDelegate: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetApprovalDelegationOptionQuery(options) {
  const _useQuery7 = useQuery(Queries.GET_APPROVAL_DELEGATION_OPTION_QUERY, options),
    {
      data
    } = _useQuery7,
    rest = _objectWithoutPropertiesLoose(_useQuery7, _excluded27);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getApprovalDelegationOption: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetApprovalDelegationOptionLazyQuery(options) {
  const [getter, _ref15] = useLazyQuery(Queries.GET_APPROVAL_DELEGATION_OPTION_QUERY, options);
  const {
      data
    } = _ref15,
    rest = _objectWithoutPropertiesLoose(_ref15, _excluded28);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getApprovalDelegationOption: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetApprovalDelegationOptionSuspenseQuery(options) {
  const _useSuspenseQuery7 = useSuspenseQuery(Queries.GET_APPROVAL_DELEGATION_OPTION_QUERY, options),
    {
      data
    } = _useSuspenseQuery7,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery7, _excluded29);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getApprovalDelegationOption: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function usePutApprovalDelegationOptionMutation(options) {
  const [getter, _ref16] = useMutation(Queries.PUT_APPROVAL_DELEGATION_OPTION_MUTATION, options);
  const {
      data
    } = _ref16,
    rest = _objectWithoutPropertiesLoose(_ref16, _excluded30);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    putApprovalDelegationOption: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}